import * as React from 'react';
import SlickSliderBase, { Settings } from 'react-slick';

import './SlickSlider.css';

export type TSlickSettings = Settings;

interface ISlickSliderProps {
  settings: TSlickSettings;
  className?: string;
  children: React.ReactNode;
}

export const SlickSlider: React.FC<ISlickSliderProps> = ({ settings, className, children }) => {
  return (
    <SlickSliderBase {...settings} className={className}>
      {children}
    </SlickSliderBase>
  );
};
